import { generateStatusLabel } from '../../ScreenJourneys/utils/journeyText/textComponents';

export const NOT_AVAILABLE = 'n/a';
export const MAU_OVERAGE_PRICE_PER_1000 = 5;
export const MAU_COUNT_DIVIDER = 1000;
export const DEFAULT_MAU_COUNT = 0;

export const ACTIVE_STATUS = 'ACTIVE';
export const INACTIVE_STATUS = 'INACTIVE';
export const TRIAL_STATUS = 'TRIAL';

export const DEFAULT_INACTIVE_PRODUCTS = [
  {
    name: 'Journeys',
    status: 'inactive',
  },
  {
    name: 'Universal Ads',
    status: 'inactive',
  },
  {
    name: 'Universal Email',
    status: 'inactive',
  },
  {
    name: 'Data Feeds',
    status: 'inactive',
  },
];

export const ACTIVE_DEFAULT_PRODUCT_LINK_PATHS = {
  Journeys: {
    path: '/web/journeys/activity',
  },
  'Universal Ads': {
    path: '/ads/analytics/activity',
  },
  'Universal Email': {
    path: '/email/activity',
  },
  'Data Feeds': {
    path: '/data-feeds/manager',
  },
  'Deep Linked Email': {
    path: '/email/activity',
  },
};

export const INACTIVE_DEFAULT_PRODUCT_LINK_PATHS = {
  Journeys: {
    app: '/web/journeys/landing',
    org: '/journeys',
  },
  'Universal Ads': {
    app: '/ads/landing',
    org: '/universal-ads',
  },
  'Universal Email': {
    app: '/email/landing',
    org: '/universal-email',
  },
  'Data Feeds': {
    app: '/data-import-export/data-feeds/manager/landing',
    org: '/data-feeds/',
  },
  'Deep Linked Email': {
    app: '/email/landing',
    org: '/universal-email',
  },
};

export const NEVER_DISPLAY_PRODUCTS = [
  'MobileAppTracking',
  'AttributionAnalytics',
  'Data Partnership',
  'Self-Serve Base Platform',
];

export const ALWAYS_DISPLAY_PRODUCTS = ['Journeys', 'Universal Ads', 'Deep Linked Email', 'Universal Email', 'Data Feeds'];

export const ENABLE_CANCEL_PRODUCTS = [
  'Journeys',
  'Universal Ads',
  'Deep Linked Email',
  'Universal Email',
  'Data Feeds',
  'Cross-platform ID',
  'Data Integrations',
  'Deep Linked Feeds',
];

export const SELF_SERVE_BASE_PRODUCTS = ['Universal Ads'];

// Invoice Canceled status
export const CANCELED = 'Canceled';

export const CREDIT_CARD_IMAGES = {
  Visa: 'visa_logo.png',
  AmericanExpress: 'amex_logo.png',
  MasterCard: 'mastercard_logo.png',
  Discover: 'discover_logo.png',
};

export const ACCOUNT_BILLING_PATH = '/account-settings/billing';

export const HISTORICAL_MAU_PATH = `${ACCOUNT_BILLING_PATH}/historical-mau`;

export const INVOICE_TABLE_COLUMNS = [
  {
    display: 'INVOICE DATE',
    key: 'date',
    no_sort: true,
    width: '25%',
  },
  {
    display: 'DUE DATE',
    key: 'dueDate',
    no_sort: true,
    width: '25%',
  },
  {
    display: 'INVOICE AMOUNT',
    key: 'amount',
    no_sort: true,
    width: '30%',
    className: 'h_jc-fe',
  },
  {
    display: 'DOWNLOAD',
    key: 'download',
    no_sort: true,
    width: '20%',
    className: 'h_jc-c',
  },
];

export const SUBSCRIBED_PRODUCT_COLUMNS = [
  {
    display: 'PRODUCTS',
    key: 'products',
    no_sort: true,
  },
  {
    display: 'STATUS',
    key: 'status',
    formatter: generateStatusLabel,
    no_sort: true,
  },
  {
    display: 'ACTION',
    key: 'action',
    no_sort: true,
    width: '20%',
  },
];

export const DELETE_PAYMENT_WARNING_TEXT = 'Note: you need at least one credit card on file to use your plan';
